import { authFetch } from '../utils/auth';

/**
 * Fetch the list of notifications for the current user.
 * @returns {Promise<Array>} notifications
 */
export const fetchNotifications = async () => {
  const response = await authFetch('/api/notifications');
  if (!response.ok) {
    throw new Error(`Failed to fetch notifications: ${response.statusText}`);
  }
  return response.json();
};

/**
 * Dismiss a notification by id.
 * @param {string} id
 * @returns {Promise<boolean>} success
 */
export const dismissNotification = async (id) => {
  const response = await authFetch(`/api/notifications/${id}/dismiss`, {
    method: 'POST',
  });
  if (!response.ok) {
    throw new Error(`Failed to dismiss notification: ${response.statusText}`);
  }
  return true;
};
